import { render, staticRenderFns } from "./AppDataTable.vue?vue&type=template&id=70f83f63&"
import script from "./AppDataTable.vue?vue&type=script&lang=ts&"
export * from "./AppDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./AppDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VDivider,VPagination,VRow,VSpacer})
